(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meayurv-contact-form"] && !Shopify.designMode) return;
  try {
    
/* Phone check per selected country. Primary: Google's libphonenumber (self-hosted
   max bundle, window.libphonenumber) — full per-country validation via isValid().
   Fallback when the library hasn't loaded: the data-digits length map on the <option>.
   LENIENT on purpose: empty field is always valid (phone stays optional); a pasted
   country code and/or a leading trunk 0 are forgiven; an unknown country code means
   NO check (never a false error). Uses native setCustomValidity so the browser
   blocks submit + shows the message itself. */
(function () {
  if (window.__mayContactPhoneInit) return;
  window.__mayContactPhoneInit = true;

  function candidatesFor(digits, cc) {
    var out = [digits];
    if (digits.charAt(0) === '0') out.push(digits.replace(/^0+/, ''));
    if (cc && digits.indexOf(cc) === 0) {
      var rest = digits.slice(cc.length);
      out.push(rest);
      if (rest.charAt(0) === '0') out.push(rest.replace(/^0+/, ''));
    }
    return out;
  }

  function googleVerdict(cands, cc, label) {
    var lp = window.libphonenumber;
    if (!lp || !lp.parsePhoneNumberFromString) return null; // library not available
    var sawKnownCountry = false;
    var tooShort = false;
    var tooLong = false;
    for (var i = 0; i < cands.length; i++) {
      var full = '+' + cc + cands[i];
      try {
        var parsed = lp.parsePhoneNumberFromString(full);
        if (parsed && parsed.isValid()) return ''; // valid → no error
        if (parsed) sawKnownCountry = true;
        var len = lp.validatePhoneNumberLength(full);
        if (len === 'INVALID_COUNTRY') continue;
        sawKnownCountry = true;
        if (len === 'TOO_SHORT') tooShort = true;
        if (len === 'TOO_LONG') tooLong = true;
      } catch (err) { /* treat as unknown */ }
    }
    if (!sawKnownCountry) return null; // unknown calling code → skip, never false-error
    if (tooShort && !tooLong) return 'This number looks too short for ' + label + ' — please check it.';
    if (tooLong && !tooShort) return 'This number looks too long for ' + label + ' — please check it.';
    return "This doesn't look like a valid " + label + ' number — please check it.';
  }

  function specVerdict(cands, spec, label) {
    if (!spec) return '';
    var m = spec.split('-');
    var min = parseInt(m[0], 10);
    var max = parseInt(m[1] || m[0], 10);
    if (!min || !max) return '';
    var ok = cands.some(function (d) { return d.length >= min && d.length <= max; });
    if (ok) return '';
    var expected = min === max ? min + ' digits' : min + '–' + max + ' digits';
    return 'A ' + label + ' number has ' + expected + ' — please check the number.';
  }

  function validate(wrap) {
    var sel = wrap.querySelector('.may-cform__cc');
    var inp = wrap.querySelector('input[type="tel"]');
    if (!sel || !inp) return;

    inp.setCustomValidity('');
    wrap.classList.remove('is-invalid');

    var raw = inp.value.trim();
    if (!raw) return;

    var ccMatch = sel.value.match(/\+(\d+)/);
    var cc = ccMatch ? ccMatch[1] : '';
    if (!cc) return;

    var digits = raw.replace(/\D/g, '');
    if (!digits) return;
    var cands = candidatesFor(digits, cc);

    var msg = googleVerdict(cands, cc, sel.value);
    if (msg === null) {
      var optEl = sel.options[sel.selectedIndex];
      msg = specVerdict(cands, optEl ? optEl.getAttribute('data-digits') : null, sel.value);
    }
    if (msg) {
      inp.setCustomValidity(msg);
      wrap.classList.add('is-invalid');
    }
  }

  function handler(e) {
    var wrap = e.target.closest && e.target.closest('.may-cform__phonewrap');
    if (wrap) validate(wrap);
  }
  document.addEventListener('input', handler);
  document.addEventListener('change', handler);
})();

  } catch(e) { console.error(e); }
})();
})();
